import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginModule } from '../login/login.module';
import { NavbarComponent } from './navbar/navbar.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { AdminLoginPageComponent } from './admin-login-page/admin-login-page.component';
import { ThemeRoutingModule} from "./theme-routing.module";
import { SharedModule } from "../shared/shared.module";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { SsoPageComponent } from './sso-page/sso-page.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavBarService } from './services/nav-bar.service';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  imports: [
    RouterModule
    ,LoginModule
    ,SharedModule
    ,ThemeRoutingModule
  ],
  declarations: [PageNotFoundComponent,NavbarComponent, LoginPageComponent, AdminLoginPageComponent, SsoPageComponent, SidebarComponent, FooterComponent
]
  ,exports: [NavbarComponent, PageNotFoundComponent, SidebarComponent, FooterComponent]
  , schemas: [ NO_ERRORS_SCHEMA ]
  , providers: [NavBarService]
})
export class ThemeModule { }



// WEBPACK FOOTER //
// ./src/app/theme/theme.module.ts